import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LoadingScreenService, QueryBuilderService } from '@giglio-com/ng-libraries/dist';
import { Observable, pluck, tap } from 'rxjs';
import { GetPartnerListGQL } from 'src/graphql';

@Injectable({
  providedIn: 'root',
})
export class PartnerListResolver implements Resolve<any> {
  constructor(
    private queryBuilder: QueryBuilderService,
    private partnersList: GetPartnerListGQL,
    private loadingScreen: LoadingScreenService
  ) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    this.loadingScreen.start();
    this.queryBuilder.do(
      {
        pagination: {
          limit: 20,
        },
      },
      route.queryParams.qb
    );
    return this.partnersList
      .fetch({
        data: this.queryBuilder.getQb(),
      })
      .pipe(
        pluck('data'),
        tap(() => this.loadingScreen.stop())
      );
  }
}
